import React, { useEffect } from 'react';
import { Typography, Container, Box, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/login'); // Redirigir al login
    }, 5000); // 5 segundos

    return () => clearTimeout(timer);
  }, [navigate]);

  // Determine image size based on device
  const getImageSize = () => {
    if (isMobile) {
      return { maxWidth: '85%', my: 2 };
    } else if (isTablet) {
      return { maxWidth: '75%', my: 2 };
    }
    return { maxWidth: 600, my: 3 };
  };

  // Determine typography size based on device
  const getTypographySize = (variant) => {
    if (isMobile) {
      // Reducir tamaños para móviles
      switch (variant) {
        case 'h4': return 'h5';
        case 'body1': return 'body2';
        case 'body2': return 'caption';
        default: return variant;
      }
    }
    return variant;
  };

  return (
    <Container 
      maxWidth="md" 
      sx={{ 
        mt: isMobile ? 2 : 4, 
        p: isMobile ? 2 : 3,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: isMobile ? '80vh' : '60vh'
      }}
    >
      <Box
        component="img"
        src="/images/unauthorized.webp"
        alt="No tienes acceso"
        sx={{
          width: '100%',
          height: 'auto',
          mx: 'auto',
          ...getImageSize(),
        }}
      />
      <Typography 
        variant={getTypographySize('h4')} 
        color="error" 
        gutterBottom
      >
        Acceso No Autorizado
      </Typography>
      <Typography 
        variant={getTypographySize('body1')} 
        gutterBottom
        sx={{ px: isMobile ? 1 : 0 }}
      >
        No tienes permiso para acceder a esta página.
      </Typography>
      <Typography 
        variant={getTypographySize('body2')} 
        color="text.secondary"
        sx={{ mt: 1 }}
      >
        Serás redirigido al inicio de sesión en unos segundos...
      </Typography>
    </Container>
  );
};

export default UnauthorizedPage;